module.exports = __webpack_public_path__ + "static/media/palm-mountain-bg.54a3e999.jpg";